(() => {
  if (customElements.get('ct-avatar-rotator')) return;

  class CtAvatarRotator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.items = Array.from(this.querySelectorAll('[data-ct-avatar-item]'));
      this.enabled = this.dataset.rotate === 'true' && this.items.length > 3;
      this.interval = Math.min(8000, Math.max(2000, Number(this.dataset.interval) || 3000));
      this.startIndex = 0;
      this.pointerPaused = false;
      this.focusPaused = false;
      this.inViewport = !('IntersectionObserver' in window);
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onPointerEnter = () => {
        this.pointerPaused = true;
        this.syncTimer();
      };
      this.onPointerLeave = () => {
        this.pointerPaused = false;
        this.syncTimer();
      };
      this.onFocusIn = () => {
        this.focusPaused = true;
        this.syncTimer();
      };
      this.onFocusOut = (event) => {
        if (this.contains(event.relatedTarget)) return;
        this.focusPaused = false;
        this.syncTimer();
      };
      this.onVisibilityChange = () => this.syncTimer();
      this.onMotionChange = () => this.syncTimer();

      this.addEventListener('pointerenter', this.onPointerEnter);
      this.addEventListener('pointerleave', this.onPointerLeave);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      this.motionQuery.addEventListener?.('change', this.onMotionChange);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.inViewport = Boolean(entry?.isIntersecting);
            this.syncTimer();
          },
          { threshold: 0.1 }
        );
        this.observer.observe(this);
      }

      this.renderWindow();
      this.syncTimer();
    }

    disconnectedCallback() {
      window.clearTimeout(this.timerId);
      this.observer?.disconnect();
      this.removeEventListener('pointerenter', this.onPointerEnter);
      this.removeEventListener('pointerleave', this.onPointerLeave);
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('focusout', this.onFocusOut);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.motionQuery?.removeEventListener?.('change', this.onMotionChange);
      this.initialized = false;
    }

    shouldRotate() {
      return (
        this.enabled &&
        this.inViewport &&
        !document.hidden &&
        !this.motionQuery.matches &&
        !this.pointerPaused &&
        !this.focusPaused
      );
    }

    syncTimer() {
      window.clearTimeout(this.timerId);
      this.timerId = undefined;
      if (!this.shouldRotate()) return;

      this.timerId = window.setTimeout(() => {
        this.startIndex = (this.startIndex + 1) % this.items.length;
        this.renderWindow();
        this.syncTimer();
      }, this.interval);
    }

    renderWindow() {
      this.items.forEach((item, index) => {
        const relativeIndex = (index - this.startIndex + this.items.length) % this.items.length;
        item.classList.toggle('is-visible', relativeIndex < 3);
      });
    }
  }

  customElements.define('ct-avatar-rotator', CtAvatarRotator);
})();

